import { useReducer } from 'react';
/**
 * Returns the value and a function that toggles between the initial value and it's opposite.
 * @param initialState - Initial state, defaults to `false`.
 */
export default function useToggle(initialState = false) {
  return useReducer((state) => !state, initialState);
}
